// @flow
import React from 'react';
import moment from 'moment';

export type Props = {
  value?: Date | string,
  className?: string,
};

const FormattedDate = ({value, className}: Props) => (
  <span className={className}>
    {moment(value).format('YYYY-MM-DD')}
  </span>
);

export default FormattedDate;



// WEBPACK FOOTER //
// ./src/components/FormattedDate/FormattedDate.js